var _Path, _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
var SvgSignout = function SvgSignout(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "signout_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#signout_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M5.308 20.5c-.505 0-.933-.175-1.283-.525a1.745 1.745 0 0 1-.525-1.283V5.308c0-.505.175-.933.525-1.283.35-.35.778-.525 1.283-.525h5.952c.212 0 .39.072.534.215a.726.726 0 0 1 .216.535.726.726 0 0 1-.216.535.726.726 0 0 1-.534.215H5.308a.294.294 0 0 0-.212.096.294.294 0 0 0-.096.212v13.384c0 .077.032.148.096.212a.294.294 0 0 0 .212.096h5.952c.212 0 .39.072.534.215a.726.726 0 0 1 .216.535.726.726 0 0 1-.216.535.726.726 0 0 1-.534.215H5.308Zm12.31-7.75H9.845a.726.726 0 0 1-.534-.215.726.726 0 0 1-.216-.535c0-.213.072-.391.216-.535a.726.726 0 0 1 .534-.215h7.771l-1.923-1.923a.707.707 0 0 1-.212-.507.74.74 0 0 1 .212-.531.72.72 0 0 1 .527-.24.716.716 0 0 1 .542.224l3.095 3.094c.18.181.27.392.27.633s-.09.452-.27.633l-3.095 3.094a.714.714 0 0 1-.53.22.752.752 0 0 1-.539-.236.732.732 0 0 1-.21-.534.737.737 0 0 1 .226-.52l1.907-1.907Z",
    fill: "currentColor"
  }))));
};
export default SvgSignout;